import {
    GET_CHARGEBACK_MONITORING_LIST,
    GET_CHARGEBACK_MONITORING_LIST_SUCCESS,
    GET_CHARGEBACK_MONITORING_SEARCH,
    GET_CHARGEBACK_MONITORING_SEARCH_SUCCESS,
    CHARGEBACK_MONITORING_API_ERROR
} from "./actionTypes"

export const getChargebackMonitoringList = record => ({
    type: GET_CHARGEBACK_MONITORING_LIST,
    payload: record
})

export const getChargebackMonitoringListSuccess = record => ({
    type: GET_CHARGEBACK_MONITORING_LIST_SUCCESS,
    payload: record
})

export const getChargebackMonitoringSearch = record => ({
    type: GET_CHARGEBACK_MONITORING_SEARCH,
    payload: record,
})
export const getChargebackMonitoringSearchSuccess = record => ({
    type: GET_CHARGEBACK_MONITORING_SEARCH_SUCCESS,
    payload: record,
})

export const chargebackMonitoringApiError = error => {
    return {
        type: CHARGEBACK_MONITORING_API_ERROR,
        payload: error,
    }
}
